import CraneInspectionContainer from './containers/CraneInspectionContainer';

export default CraneInspectionContainer;

export {uiDataCraneInspection, serverDataCraneInspection} from './reducers/CraneInspectionReducer';
